/**
 * Shared UI component for UI Form Section.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { UiCardComponent } from '../ui-card/ui-card.component';
import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-form-section',
  standalone: true,
  imports: [UiCardComponent, UiLabelTranslatePipe],
  templateUrl: './ui-form-section.component.html',
  styleUrl: './ui-form-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiFormSectionComponent {
  readonly title = input.required<string>();
  readonly description = input('');
  readonly required = input(false);
  readonly variant = input<'default' | 'compact'>('default');
}
